/** Preload image URLs in the background (deduped). */
export const preloadImages = (urls: (string | null | undefined)[]) => {
  const unique = [...new Set(urls.filter((url): url is string => Boolean(url)))];

  unique.forEach((src) => {
    const img = new Image();
    img.decoding = "async";
    img.src = src;
  });
};
